/**
 * A config containing properties for navigation items
 */
var NavigationItemBase = /** @class */ (function () {
    function NavigationItemBase() {
    }
    return NavigationItemBase;
}());
export { NavigationItemBase };
//# sourceMappingURL=navigation-item-base.js.map